package org.example.project.ui

import androidx.compose.animation.animateColorAsState
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.scale
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import com.battleships.quiz.Question
import org.example.project.viewmodel.GameViewModel

@Composable
fun QuestionDialog(
    question: Question,
    viewModel: GameViewModel,
    onAnswer: (String) -> Unit
) {

    var answer by remember {
        mutableStateOf("")
    }

    Dialog(
        onDismissRequest = {}
    ) {

        Surface(
            modifier = Modifier
                .fillMaxWidth()
                .padding(16.dp),

            shape = RoundedCornerShape(16.dp),

            color = Color(0xFF0A192F),

            border = BorderStroke(
                2.dp,
                Color(0xFF00CFFF)
            )
        ) {

            Column(
                modifier = Modifier
                    .padding(24.dp),

                horizontalAlignment =
                    Alignment.CenterHorizontally
            ) {

                Text(
                    text = "ACQUIRING TARGETING INTEL",
                    color = Color(0xFF00CFFF),
                    fontWeight = FontWeight.Bold,
                    fontSize = 22.sp,
                    textAlign = TextAlign.Center
                )

                Spacer(
                    Modifier.height(24.dp)
                )

                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.Top
                ){
                    Text(
                        text = question.question,
                        modifier = Modifier.weight(1f),
                        color = Color.White,
                        textAlign = TextAlign.Start,
                        fontSize = 18.sp
                    )
                    Spacer(
                        Modifier.width(10.dp)
                    )
                    QuestionTimer(viewModel)
                }

                Spacer(
                    Modifier.height(18.dp)
                )

                OutlinedTextField(

                    value = answer,

                    onValueChange = {
                        answer = it
                    },

                    modifier =
                        Modifier.fillMaxWidth(),

                    label = {
                        Text("Your Answer")
                    },

                    singleLine = true,

                    colors =
                        OutlinedTextFieldDefaults.colors(

                            focusedBorderColor =
                                Color(0xFF00CFFF),

                            focusedLabelColor =
                                Color(0xFF00CFFF),

                            focusedTextColor =
                                Color.White,

                            unfocusedTextColor =
                                Color.White,

                            cursorColor =
                                Color(0xFF00CFFF)
                        )
                )

                Spacer(
                    Modifier.height(32.dp)
                )

                Button(

                    onClick = {

                        onAnswer(answer)

                    },

                    enabled =
                        answer.isNotBlank(),

                    modifier =
                        Modifier
                            .fillMaxWidth()
                            .height(52.dp),

                    colors =
                        ButtonDefaults.buttonColors(
                            containerColor =
                                Color(0xFF00CFFF),

                            contentColor =
                                Color(0xFF0A192F)
                        )
                ) {

                    Text(
                        "SUBMIT",
                        fontWeight =
                            FontWeight.Bold
                    )
                }
            }
        }
    }
}
@Composable
private fun QuestionTimer(
    viewModel: GameViewModel
) {
    val animatedColor by animateColorAsState(
        targetValue = when {

            viewModel.questionTimeRemaining <= 10 ->
                Color.Red

            viewModel.questionTimeRemaining <= 20 ->
                Color(0xFFFF9800)

            else ->
                Color(0xFF00FFFF)
        },

        animationSpec = tween(500)
    )

    val infiniteTransition =
        rememberInfiniteTransition()

    val scale by infiniteTransition.animateFloat(
        initialValue = 1f,
        targetValue =
            if (viewModel.questionTimeRemaining <= 10)
                1.12f
            else
                1.03f,

        animationSpec =
            infiniteRepeatable(
                tween(550),
                RepeatMode.Reverse
            )
    )

    Surface(
        modifier = Modifier.wrapContentSize(),
        color = Color(0xFF001B33),
        border = BorderStroke(
            2.dp,
            animatedColor
        ),
        shape = RoundedCornerShape(14.dp)
    ) {

        Column(
            modifier = Modifier.padding(
                horizontal = 20.dp,
                vertical = 14.dp
            ),
            horizontalAlignment =
                Alignment.CenterHorizontally
        ) {

            Text(
                "MISSION TIMER",
                color = Color.White,
                fontSize = 12.sp,
                fontWeight = FontWeight.Bold
            )

            Spacer(
                Modifier.height(6.dp)
            )

            Text(
                text = "${viewModel.formattedTime()}",
                modifier = Modifier.scale(scale),
                fontSize = 25.sp,
                fontWeight = FontWeight.ExtraBold,
                color = animatedColor
            )

            Spacer(
                Modifier.height(4.dp)
            )

            Text(
                text =
                    when {

                        viewModel.questionTimeRemaining <= 10 ->
                            "TIME RUNNING OUT"

                        else ->
                            "Awaiting Response"
                    },

                color = animatedColor.copy(alpha = 0.8f),
                fontSize = 11.sp
            )
        }
    }
}